function PrivacyPolicies() {
  return (
    <main className="h-svh overflow-y-scroll">
      <div className="mx-auto max-w-screen-lg px-4 py-4 md:px-8 md:py-8">
        <h1 className="text-center text-lg font-bold">
          Política de privacidade
        </h1>
        <p className="mt-6 text-base">
          <strong>1. APRESENTA&Ccedil;&Atilde;O E OBJETO</strong>
        </p>

        <p className="mt-3 text-justify text-sm">
          Esta Pol&iacute;tica de Privacidade tem como finalidade estabelecer de
          forma clara, objetiva e acess&iacute;vel as regras para a coleta,
          utiliza&ccedil;&atilde;o, armazenamento, prote&ccedil;&atilde;o,
          compartilhamento e demais formas de tratamento de dados pessoais dos
          usu&aacute;rios da plataforma digital GPMED, administrada por&nbsp;
          <strong>GPMED LTDA</strong>, pessoa jur&iacute;dica de direito
          privado, inscrita no CNPJ sob o n&ordm; 50.327.373/0001-40, com sede
          em S&atilde;o Jos&eacute; do Rio Preto/SP.
        </p>
        <p className="mt-3 text-justify text-sm">
          A GPMED LTDA atua como&nbsp;
          <strong>Controladora de Dados Pessoais</strong>, nos termos da Lei
          n&ordm; 13.709/2018 &ndash; Lei Geral de Prote&ccedil;&atilde;o de
          Dados Pessoais (LGPD), adotando as melhores pr&aacute;ticas de&nbsp;
          <strong>
            seguran&ccedil;a da informa&ccedil;&atilde;o, governan&ccedil;a de
            dados e privacidade digital
          </strong>
          , em conformidade com:
        </p>

        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Lei Geral de Prote&ccedil;&atilde;o de Dados Pessoais &ndash; LGPD
            (Lei n&ordm; 13.709/2018);
          </strong>
        </p>

        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Marco Civil da Internet (Lei n&ordm; 12.965/2014);</strong>
        </p>

        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            C&oacute;digo de Defesa do Consumidor (Lei n&ordm; 8.078/1990);
          </strong>
        </p>

        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Lei de Direitos Autorais (Lei n&ordm; 9.610/1998);</strong>
        </p>

        <p className="mt-3 text-justify text-sm">
          <span>● </span>E demais normas correlatas aplic&aacute;veis ao
          ambiente digital, educacional e tecnol&oacute;gico.
        </p>

        <p className="mt-6 text-justify text-base">
          <strong>2. DEFINI&Ccedil;&Otilde;ES</strong>
        </p>

        <p className="mt-3 text-justify text-sm">
          Para os fins desta Pol&iacute;tica, adotam-se as seguintes
          defini&ccedil;&otilde;es:
        </p>

        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Dados pessoais</strong>: informa&ccedil;&atilde;o relacionada
          a pessoa natural identificada ou identific&aacute;vel.
        </p>

        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Dados pessoais sens&iacute;veis</strong>: dados sobre origem
          racial ou &eacute;tnica, convic&ccedil;&atilde;o religiosa,
          opini&atilde;o pol&iacute;tica, sa&uacute;de, vida sexual, dados
          gen&eacute;ticos ou biom&eacute;tricos.
        </p>

        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Titular</strong>: pessoa natural a quem os dados pessoais se
          referem.
        </p>

        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Tratamento</strong>: qualquer opera&ccedil;&atilde;o realizada
          com dados, como coleta, uso, acesso, compartilhamento, armazenamento
          ou elimina&ccedil;&atilde;o.
        </p>

        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Controladora</strong>: pessoa jur&iacute;dica
          respons&aacute;vel pelas decis&otilde;es referentes ao tratamento de
          dados.
        </p>

        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Operador</strong>: terceiro que realiza o tratamento de dados
          em nome da controladora.
        </p>

        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>DPO (Encarregado de Dados)</strong>: pessoa designada para
          atuar como canal de comunica&ccedil;&atilde;o entre o titular, o
          controlador e a ANPD.
        </p>

        <p className="mt-6 text-justify text-base">
          <strong>3. IDENTIFICA&Ccedil;&Atilde;O DO CONTROLADOR</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          <strong>GPMED LTDA</strong>
        </p>
        <p className="mt-3 text-justify text-sm">CNPJ: 50.327.373/0001-40</p>
        <p className="mt-3 text-justify text-sm">
          Sede: Av. Presidente Juscelino Kubitschek de Oliveira, n&ordm; 1600
          &ndash; Jardim Tarraf II &ndash; S&atilde;o Jos&eacute; do Rio
          Preto/SP &ndash; CEP 15092-415
        </p>
        <p className="mt-3 text-justify text-sm">
          E-mail para contato com o DPO:&nbsp;
          <a href="mailto:contato@oguiadeprescricao.com.br">
            <strong>contato@oguiadeprescricao.com.br</strong>
          </a>
        </p>

        <p className="mt-6 text-justify text-base">
          <strong>4. CATEGORIAS DE DADOS TRATADOS</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          A GPMED LTDA poder&aacute; realizar o tratamento das seguintes
          categorias de dados:
        </p>
        <p className="mt-3 text-justify text-sm">
          <strong>4.1 Dados fornecidos diretamente pelo titular:</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Nome completo, e-mail, CPF, telefone, data de nascimento, ano de
          forma&ccedil;&atilde;o, &aacute;rea de atua&ccedil;&atilde;o, cidade e
          estado que atua;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          N&uacute;mero do CRM ou comprovante de v&iacute;nculo acad&ecirc;mico
          (quando aplic&aacute;vel);
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Dados banc&aacute;rios para emiss&atilde;o de cobran&ccedil;a ou
          reembolso.
        </p>

        <p className="mt-3 text-justify text-sm">
          <strong>4.2 Dados coletados automaticamente:</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Endere&ccedil;o IP, localiza&ccedil;&atilde;o geogr&aacute;fica, tipo
          de dispositivo e navegador;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Dados de navega&ccedil;&atilde;o, tempo de perman&ecirc;ncia,
          prefer&ecirc;ncias de conte&uacute;do.
        </p>

        <p className="mt-3 text-justify text-sm">
          <strong>4.3 Dados de terceiros (se for o caso):</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Login por redes sociais, autentica&ccedil;&atilde;o via Google, Apple
          ID ou parceiros educacionais.
        </p>

        <p className="mt-3 text-justify text-sm">
          <strong>4.4 Dados de menores de idade:</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          A GPMED LTDA&nbsp;
          <strong>
            n&atilde;o realiza tratamento de dados de menores de 18 anos
          </strong>
          . Caso venha a tratar dados de estudantes legalmente emancipados ou
          com consentimento dos pais/respons&aacute;veis, adotar&aacute;
          procedimentos espec&iacute;ficos, com consentimento destacado, nos
          termos do art. 14 da LGPD.
        </p>

        <p className="mt-6 text-justify text-base">
          <strong>5. FINALIDADES DO TRATAMENTO</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          A coleta e tratamento de dados pessoais t&ecirc;m por finalidade:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Executar e gerenciar o cadastro e autentica&ccedil;&atilde;o do
          usu&aacute;rio;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Disponibilizar conte&uacute;dos t&eacute;cnicos e cient&iacute;ficos
          personalizados;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Processar pagamentos, emitir faturas e notas fiscais;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Realizar comunica&ccedil;&otilde;es administrativas, t&eacute;cnicas e
          promocionais;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Cumprir obriga&ccedil;&otilde;es legais, fiscais, regulat&oacute;rias
          e contratuais;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Monitorar a seguran&ccedil;a da plataforma, detectar fraudes e abusos;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Promover a melhoria cont&iacute;nua da experi&ecirc;ncia do
          usu&aacute;rio, com base em dados estat&iacute;sticos anonimizados.
        </p>

        <p className="mt-6 text-justify text-base">
          <strong>6. BASES LEGAIS</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          O tratamento de dados ser&aacute; fundamentado em, pelo menos, uma das
          seguintes hip&oacute;teses legais:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Execu&ccedil;&atilde;o de contrato</strong>
          &nbsp;(art. 7&ordm;, V da LGPD);
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Consentimento livre, informado e inequ&iacute;voco do titular
          </strong>
          &nbsp;(art. 7&ordm;, I);
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>
            Cumprimento de obriga&ccedil;&atilde;o legal ou regulat&oacute;ria
          </strong>
          &nbsp;(art. 7&ordm;, II);
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Exerc&iacute;cio regular de direitos</strong>
          &nbsp;(art. 7&ordm;, VI);
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Leg&iacute;timo interesse da controladora</strong>,
          respeitados os direitos e liberdades fundamentais (art. 7&ordm;, IX).
        </p>

        <p className="mt-6 text-justify text-base">
          <strong>7. COMPARTILHAMENTO DE DADOS</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          O compartilhamento de dados poder&aacute; ocorrer com:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Prestadores de servi&ccedil;o de tecnologia, hospedagem,
          cobran&ccedil;a e atendimento;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Autoridades p&uacute;blicas ou &oacute;rg&atilde;os de
          fiscaliza&ccedil;&atilde;o, quando houver obriga&ccedil;&atilde;o
          legal;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Conselhos profissionais ou institui&ccedil;&otilde;es de ensino,
          mediante consentimento ou requisi&ccedil;&atilde;o expressa.
        </p>
        <p className="mt-3 text-justify text-sm">
          Todos os terceiros contratados firmam&nbsp;
          <strong>termo de confidencialidade</strong>
          &nbsp;e est&atilde;o obrigados a adotar medidas compat&iacute;veis com
          a LGPD.
        </p>

        <p className="mt-6 text-justify text-base">
          <strong>
            8. UTILIZA&Ccedil;&Atilde;O DE COOKIES E TECNOLOGIAS DE RASTREAMENTO
          </strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          Cookies s&atilde;o arquivos instalados no dispositivo do
          usu&aacute;rio que permitem a coleta de dados de
          navega&ccedil;&atilde;o para finalidades funcionais e
          estat&iacute;sticas.
        </p>
        <p className="mt-3 text-justify text-sm">Tipos utilizados:</p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Essenciais</strong>: para funcionamento da plataforma;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Anal&iacute;ticos</strong>: para mensura&ccedil;&atilde;o de
          performance;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Funcionais</strong>: para lembrar prefer&ecirc;ncias e
          sess&otilde;es;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          <strong>Marketing</strong>: para comunica&ccedil;&atilde;o segmentada,
          quando autorizado.
        </p>
        <p className="mt-3 text-justify text-sm">
          O usu&aacute;rio poder&aacute;, a qualquer momento, configurar seu
          navegador para recusar cookies, podendo haver limita&ccedil;&otilde;es
          no uso de determinadas funcionalidades.
        </p>

        <p className="mt-6 text-justify text-base">
          <strong>9. ARMAZENAMENTO E RETEN&Ccedil;&Atilde;O DOS DADOS</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          Os dados s&atilde;o armazenados de forma segura e ser&atilde;o
          retidos:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Pelo per&iacute;odo necess&aacute;rio para cumprir as finalidades
          informadas;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Pelo tempo exigido por obriga&ccedil;&otilde;es legais (ex: fiscais e
          regulat&oacute;rias);
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          At&eacute; solicita&ccedil;&atilde;o de exclus&atilde;o pelo titular,
          desde que n&atilde;o haja impedimentos legais.
        </p>
        <p className="mt-3 text-justify text-sm">
          Ap&oacute;s o prazo, os dados poder&atilde;o ser anonimizados ou
          descartados com seguran&ccedil;a.
        </p>

        <p className="mt-6 text-justify text-base">
          <strong>10. DIREITOS DOS TITULARES</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          O titular poder&aacute; exercer, a qualquer momento, os direitos
          previstos na LGPD:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Confirma&ccedil;&atilde;o e acesso aos dados;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Corre&ccedil;&atilde;o de dados incompletos, inexatos ou
          desatualizados;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Anonimiza&ccedil;&atilde;o, bloqueio ou elimina&ccedil;&atilde;o de
          dados;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Portabilidade a outro fornecedor;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Informa&ccedil;&atilde;o sobre compartilhamento;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Revoga&ccedil;&atilde;o de consentimento;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Oposi&ccedil;&atilde;o ao tratamento (nos casos cab&iacute;veis).
        </p>
        <p className="mt-3 text-justify text-sm">
          As solicita&ccedil;&otilde;es devem ser enviadas ao DPO pelo
          e-mail:&nbsp;
          <a href="mailto:contato@oguiadeprescricao.com.br">
            <strong>contato@oguiadeprescricao.com.br</strong>
          </a>
          , com prazo de resposta de at&eacute;&nbsp;
          <strong>15 dias &uacute;teis</strong>.
        </p>
        <p className="mt-6 text-justify text-base">
          <strong>11. SEGURAN&Ccedil;A E GOVERNAN&Ccedil;A DE DADOS</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          A GPMED LTDA adota medidas t&eacute;cnicas, administrativas e
          organizacionais aptas a proteger os dados pessoais contra acessos
          n&atilde;o autorizados, vazamentos, destrui&ccedil;&atilde;o ou perda
          acidental, incluindo:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Criptografia de dados pessoais sens&iacute;veis;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Controle de acesso e autentica&ccedil;&atilde;o forte;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Mecanismos de rastreamento (logs) e preven&ccedil;&atilde;o de
          vazamentos;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Programas internos de&nbsp;
          <strong>governan&ccedil;a em privacidade</strong>
          &nbsp;e&nbsp;
          <strong>capacita&ccedil;&atilde;o da equipe</strong>;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Registro de opera&ccedil;&otilde;es de tratamento (ROPA) e
          avalia&ccedil;&atilde;o de riscos (DPIA), conforme o princ&iacute;pio
          da&nbsp;
          <strong>accountability</strong>
          &nbsp;(art. 37 da LGPD).
        </p>

        <p className="mt-6 text-justify text-base">
          <strong>12. TRANSFER&Ecirc;NCIA INTERNACIONAL DE DADOS</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          Poder&aacute; ocorrer tratamento de dados em servidores localizados no
          exterior, hip&oacute;tese em que ser&atilde;o adotadas:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Cl&aacute;usulas contratuais padr&atilde;o;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Certifica&ccedil;&atilde;o internacional de provedores;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Garantias t&eacute;cnicas e legais de conformidade com a LGPD;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Transfer&ecirc;ncia somente para pa&iacute;ses com grau de
          prote&ccedil;&atilde;o compat&iacute;vel reconhecido pela ANPD.
        </p>
        <p className="mt-6 text-justify text-base">
          <strong>13. REVOGA&Ccedil;&Atilde;O DE CONSENTIMENTO</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          O titular poder&aacute; revogar seu consentimento a qualquer tempo, de
          forma gratuita e facilitada, mediante solicita&ccedil;&atilde;o ao
          DPO. A revoga&ccedil;&atilde;o poder&aacute; impactar a
          utiliza&ccedil;&atilde;o de determinados recursos da plataforma.
        </p>
        <p className="mt-6 text-justify text-base">
          <strong>
            14. REGISTRO DE INCIDENTES E COMUNICA&Ccedil;&Atilde;O
          </strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          Na ocorr&ecirc;ncia de incidente de seguran&ccedil;a que possa gerar
          risco ou dano relevante, a GPMED LTDA:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Notificar&aacute; a ANPD e os titulares afetados;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Indicar&aacute; as medidas de mitiga&ccedil;&atilde;o e
          conten&ccedil;&atilde;o adotadas;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Manter&aacute; registros e documenta&ccedil;&otilde;es do evento;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Cooperar&aacute; integralmente com autoridades competentes.
        </p>
        <p className="mt-6 text-justify text-base">
          <strong>15. ATUALIZA&Ccedil;&Otilde;ES DESTA POL&Iacute;TICA</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          Esta Pol&iacute;tica poder&aacute; ser modificada a qualquer momento,
          especialmente em decorr&ecirc;ncia de:
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Atualiza&ccedil;&otilde;es legislativas;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Mudan&ccedil;as na plataforma ou nos servi&ccedil;os oferecidos;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Diretrizes da ANPD ou de &oacute;rg&atilde;os reguladores.
        </p>
        <p className="mt-3 text-justify text-sm">
          A vers&atilde;o atualizada ser&aacute; disponibilizada no site da
          GPMED LTDA, com destaque da&nbsp;
          <strong>data da &uacute;ltima altera&ccedil;&atilde;o</strong>.
        </p>

        <p className="mt-6 text-justify text-base">
          <strong>16. DISPOSI&Ccedil;&Otilde;ES FINAIS</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>
          Esta Pol&iacute;tica integra e complementa os&nbsp;
          <strong>Termos de Uso da GPMED LTDA</strong>;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>O uso continuado da plataforma implica ci&ecirc;ncia e
          concord&acirc;ncia com as disposi&ccedil;&otilde;es aqui previstas;
        </p>
        <p className="mt-3 text-justify text-sm">
          <span>● </span>A eventual toler&acirc;ncia de qualquer cl&aacute;usula
          n&atilde;o implica ren&uacute;ncia de direitos.
        </p>
        <p className="mt-6 text-justify text-base">
          <strong>17. LEGISLA&Ccedil;&Atilde;O E FORO</strong>
        </p>
        <p className="mt-3 text-justify text-sm">
          Esta Pol&iacute;tica ser&aacute; regida pelas leis da Rep&uacute;blica
          Federativa do Brasil. Fica eleito o foro da Comarca de&nbsp;
          <strong>S&atilde;o Jos&eacute; do Rio Preto/SP</strong>
          &nbsp;para dirimir eventuais controv&eacute;rsias, com ren&uacute;ncia
          expressa a qualquer outro, por mais privilegiado que seja.
        </p>
      </div>
    </main>
  );
}

export default PrivacyPolicies;
